import { Component, OnInit } from '@angular/core';
import { Policies } from '@app/auth/auth-policies';

@Component({
  selector: 'app-gift-cards',
  templateUrl: './gift-cards.component.html',
  styleUrls: ['./gift-cards.component.less'],
})
export class GiftCardsComponent {
  giftCardsOverviewPolicy = Policies.giftCardsOverview;
  giftCardsSettingsPolicy = Policies.giftCardsViewSettings;

  constructor() {}
}
